import * as v from "valibot";

export const flow_email_form_name = "pwm--email_link_login_form";

export const EmailLinkLoginSchema = v.object({
    email: v.pipe(
        v.string("Zadejte e-mail"),
        v.trim(),
        v.email("Zadejte platný e-mail"),
    ),
});

export type EmailLinkLoginFormValues = v.InferInput<typeof EmailLinkLoginSchema>;

export interface EmailLinkLoginFormProps {
    submitUrl?: string;
    initialEmail?: string;
}
